import { Component, OnInit,AfterViewInit ,OnDestroy,ViewChild,} from '@angular/core';
import { ExcelServiceService } from '../excel-service.service';
import { ModalDatasetComponent } from '../modal-dataset/modal-dataset.component';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject } from 'rxjs';
import * as firebase from 'firebase';
import{ServicioFechasQueryService} from '../servicio-fechas-query.service'
import {ModalDataUsuarioComponent } from '../modal-data-usuario/modal-data-usuario.component'
import { NgxChartsModule } from '@swimlane/ngx-charts';
import {ServiDataRegionalService} from '../servi-data-regional.service'
import {ModalAccionesEmpresaComponent } from '../modal-acciones-empresa/modal-acciones-empresa.component'
// import { ServiDataService } from '../servi-data.service';


@Component({
  selector: 'app-componente-data2',
  templateUrl: './componente-data2.component.html',
  styleUrls: ['./componente-data2.component.scss']
})
export class ComponenteData2Component implements OnInit  {

  excel=[]

  statuslimpio=true
  arraydelocaciones=[];
  botondisabled=true
  cuenca=''
  locacion=''
  alertaActiva=false
  mensajeAlerta='';
  tipodeAlerta='';

  dataChart1
  dataChart2
  datachart3
  datachart4
  datachart4v2
  dataDetalleTrabajadores=[{name:'',value:0, documentos:[]}]
  dataDetalleUnidadDeNegocio=[{name:'',value:0}]
  datasetParaModal=[]
  salida
  dataset=[]
  datasetTrabajadoresPorEmpresa=[]
  todalacuenca=false

  detalleActivo=''
  detalleBoxActivo=false
  

  constructor(private modalService: NgbModal, public servicioFechasQueryService:ServicioFechasQueryService,public serviDataregionalService:ServiDataRegionalService, public excelService:ExcelServiceService) { }

  ngOnInit(): void {
   
  }

  nuevoReporte(){
    this.serviDataregionalService.dataChart1=this.serviDataregionalService.dataChart1Default
    this.serviDataregionalService.dataChart2=this.serviDataregionalService.dataChart2Default
    this.serviDataregionalService.dataChart3=this.serviDataregionalService.dataChart3Default
    this.serviDataregionalService.dataChart4=this.serviDataregionalService.dataChart4Default
    this.serviDataregionalService.cuencaseleccionada=''
    this.serviDataregionalService.locacionSelecccionada=''
    this.arraydelocaciones=[];
    this.cuenca=''
    this.locacion=''
    this.dataChart1=undefined
    this.dataChart2=undefined
    this.datachart3=undefined
    this.datachart4=undefined
    this.dataset=[]
    this.statuslimpio=true
  }

  cargaLocaciones(seleccion){
    this.serviDataregionalService.cuencaseleccionada=seleccion
    this.arraydelocaciones=[];
    let query1 = firebase.firestore().collection("locaciones").where("regional","==",seleccion);
    query1.get().then((docs)=>{
      docs.forEach((doc)=>{
        this.arraydelocaciones.push(doc);
      })
    })
  }

  seleccionaLocacion(seleccion){
    console.log(seleccion)
    this.serviDataregionalService.locacionSelecccionada = seleccion
  }
 
  seleccionatodalacuenca(event){
    this.serviDataregionalService.todalacuenca=this.todalacuenca
  }

  generarReporte(){
    this.alertaActiva=true
    this.statuslimpio=false;
    this.serviDataregionalService.queryChart1((respuestadataChart1,respuestaChart2,respuestaChart3,respuestaChart4,respuestaDataset)=>{
      this.dataChart1 = respuestadataChart1
      this.dataChart2 = respuestaChart2
      this.datachart3 = respuestaChart3
      this.datachart4 = respuestaChart4
      this.dataset = respuestaDataset
      this.alertaActiva=false
    })
  }


  
//OPCIONES GRAFICO PIE1
viewPie=[700,400]
gradientPie=false
showLegendPie=false
legendPositionPie="below"
showLabelsPie=true
isDoughnutPie=true
labelTruncatePie=false
trimLabelsPie=false

//OPCIONES GRAFICO PIE2
  viewPie2=[900,200]
  showXAxis: boolean = true;
  showYAxis: boolean = true;
  gradient: boolean = false;
  showLegend: boolean = false;
  showXAxisLabel: boolean = true;
  yAxisLabel: string = 'Status';
  showYAxisLabel: boolean = true;
  xAxisLabel: string = 'Número de permisos';


  //OPCIONES BARRAS VERTICALES
  xAxisLabelBarrasVert = "Tipo de tarea"
  yAxisLabelBarrasVert = "Número de permisos"
  showXAxisLabelBarrasVert = true
  showYAxisLabelBarrasVert = true

  xAxisLabelBarrasVert2="Tipo de tarea"
  yAxisLabelBarrasVert2="Número de trabajadores"


  //OPCIONES BOX CHART
  cardColor: string = '#232837';
  viewBox=[700,300]



//OPCIONES DETALLE
viewDetalle=[700,400]
xAxisLabelDetalle="Número de ejecuciones"
yAxisLabelDetalle="Empresa" 


//OPCIONES DETALLE UNIDAD DE NEGOCIO
xAxisLabelUnidadNegocio="Número de trabajadores"
yAxisLabelUnidadNegocio="Empresa"
  // formatXAxisTicks(tick: any): string {
  //   return tick.length > 10 ? tick.substring(0, 10) + '...' : tick;
  // }
  
  // formatYAxisTicks(tick: any): string {
  //   return tick.toString().length > 10 ? tick.toString().substring(0, 10) + '...' : tick;
  // }




  colorScheme = {
    domain: ['#F94144', '#F3722C', '#F8961E', '#F9C74F','#90BE6D','#43AA8B','#577590']
  };





  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }
  


  onSelectSlicePietrabajadores(event){
    this.detalleActivo=''
    this.dataDetalleTrabajadores=[]
    const selectedSlice = this.datachart4.find(slice => slice.name === event.name);
    if (selectedSlice) {

      // Do something with selectedSlice.arrayDeRegistros
      selectedSlice.arrayDeRegistros.forEach((item)=>{
        this.clasificaDetalleTrabajadores(item)
      })
      this.detalleActivo=selectedSlice.name
    }
  }

  clasificaDetalleTrabajadores(item){
    
    if( this.containsName(this.dataDetalleTrabajadores,item.data().empresa, 'name').found == true){
      this.dataDetalleTrabajadores[this.containsName(this.dataDetalleTrabajadores, item.data().empresa, 'name').index ].value ++ 
      this.dataDetalleTrabajadores[this.containsName(this.dataDetalleTrabajadores, item.data().empresa, 'name').index ].name = item.data().empresa
      this.dataDetalleTrabajadores[this.containsName(this.dataDetalleTrabajadores, item.data().empresa, 'name').index ].documentos.push(item)  
    }else
    if( this.containsName(this.dataDetalleTrabajadores, item.data().empresa, 'name').found == false){
      if(item.data().empresa == undefined || item.data().empresa == ''){
        this.dataDetalleTrabajadores.push({name:"(?)--> "+item.data().ticket, value: 1, documentos:[item] })
      }else
      if(item.data().empresa != undefined && item.data().empresa != ''){
        this.dataDetalleTrabajadores.push({name:item.data().empresa, value: 1, documentos:[item]  })
      }
    }
  }

  onSelectBarTrabajadores(event){
    this.datasetTrabajadoresPorEmpresa=[]
     this.detalleActivo=''
    this.datasetParaModal=[]
    const selectedSlice = this.dataDetalleTrabajadores.find(slice => slice.name === event.name);
    if (selectedSlice) {

      this.detalleActivo=selectedSlice.name
      this.openModalDataset(event.name, this.dataset)

    }
  }

  clasificaDatasetDetalleTrabajadores(item){
    item.data().arrayDeEmpleados.forEach((element,index) => {

    // this.datasetTrabajadoresPorEmpresa.push({ticket:item.data().ticket ,id:element.id, nombre:element.nombre, actividades: element.arraydeactividades.map(item => item.actividad).join(", ") })
      element.arraydeactividades.forEach(element => {
        if(this.containsName(this.datasetTrabajadoresPorEmpresa, element.actividad, 'actividad').found == false){
          console.log()
          this.datasetTrabajadoresPorEmpresa.push({ticket:item.data().ticket,actividades:element.actividad, ejecuciones:1 })
       
        }else
        if(this.containsName(this.datasetTrabajadoresPorEmpresa, element.actividad, 'actividad').found == true){
          this.datasetTrabajadoresPorEmpresa[this.containsName(this.datasetTrabajadoresPorEmpresa, element.actividad, 'actividad').index].ejecuciones ++
        }

        // if(this.containsName(this.datasetTrabajadoresPorEmpresa, element.actividad, 'actividad').found == false){
        //   this.datasetTrabajadoresPorEmpresa.push({ticket:item.data().ticket ,id:element.id, nombre:element.nombre, actividades:element.actividad, ejecuciones:1 })
        // }else
        // if(this.containsName(this.datasetTrabajadoresPorEmpresa, element.actividad, 'actividad').found == true){
        //   this.datasetTrabajadoresPorEmpresa[this.containsName(this.datasetTrabajadoresPorEmpresa, element.actividad, 'actividad').index].ejecuciones ++
        // }
      });
      
      
    });
  }

  openModalDataset(empresa, dataset) {
    const modalRef = this.modalService.open(ModalDatasetComponent, { centered: true, size: 'lg' });
    modalRef.componentInstance.dataset = dataset;
    modalRef.componentInstance.empresa = empresa;
  }

 




  onSelectBox(event){
    this.dataDetalleUnidadDeNegocio=[]
    this.detalleBoxActivo=true
    const selectedBox= this.dataChart2.find(slice => slice.name === event.name);
    if (selectedBox) {
      // Do something with selectedSlice.arrayDeRegistros
      selectedBox.arrayDeRegistros.forEach((item)=>{
        this.clasificaDetalleUnidadesDeNegocio(item)
      })
    }
  }

  clasificaDetalleUnidadesDeNegocio(item){
    if( this.containsName(this.dataDetalleUnidadDeNegocio, item.data().empresa, 'name').found == true){
      this.dataDetalleUnidadDeNegocio[this.containsName(this.dataDetalleUnidadDeNegocio, item.data().empresa, 'name').index ].value +=  item.data().arrayDeEmpleados.length
     
    }else
    if( this.containsName(this.dataDetalleUnidadDeNegocio, item.data().empresa, 'name').found == false){
      if(item.data().empresa == undefined || item.data().empresa == ''){
        this.dataDetalleUnidadDeNegocio.push({name:"(?)--> "+item.data().ticket, value: item.data().arrayDeEmpleados.length })
      }else
      if(item.data().empresa != undefined && item.data().empresa != ''){
        this.dataDetalleUnidadDeNegocio.push({name:item.data().empresa, value: item.data().arrayDeEmpleados.length })
      }
    }
  }


  

//BUSCA SI EN EL PARAMETRO NAME DEL ARRAY DE SALIDA EXISTE EL NAME QUE ENTRA A LA FUNCION. SI SI EXISTE, RETORNA EL INDICE DONDE EST´A
  containsName(outputArray, name, param) {
    const index = outputArray.findIndex(item => item[param] === name);
    return {
      found: index !== -1,
      index: index
    };
  }
  



  generaexcel(){
    this.excel=[]
    this.generarobjetodeexcel(()=>{//primero poblaomos el array excel[] con la data del array de datos en forma de objeto
      this.exportAsXLSX();//luego si generamos el excel. 'Reporte' es el nombre del archivo.
    })
  }


    //-------- excel
    exportAsXLSX():void {
      this.excelService.exportAsExcelFile(this.excel,'Reporte');
    }
  
    //ESTO ES PARA GENERAR ARCHIVO DE EXCEL SIN DIBUJAR LA TABLA
 generarobjetodeexcel(callback){
  this.excel=[];

  this.dataset.forEach((item)=>{
    let objeto = {}
    
    objeto["Empresa"] = item.empresa
    objeto["TotalTrabajadores"] = item.totalTrabajadores
    objeto["TotalPTWS"] = item.totalPTWS
    objeto["Alturas"] = item.alturas
    objeto["Energias"] = item.energias
    objeto["Hazmat"] = item.hazmat
    objeto["Confinados"] = item.confinados
    objeto["Levantamiento"] = item.levantamiento
    objeto["Calientes"] = item.calientes
    objeto["Supervision"] = item.supervision
    objeto["Otros"] = item.otros
    objeto["Tickets"] = item.tickets

    this.excel.push(objeto)

  })
  callback()
}







alerta(tipo,input){
  this.alertaActiva=true;
  this.mensajeAlerta=input;
  this.tipodeAlerta=tipo;
}



closeAlert(){
  this.alertaActiva=false
}






}//fin de clase
